import React from 'react'
import { MotionButton, MotionDiv, MotionImage, MotionSection } from '../motion/Motion'

export default function CtaSection() {
  return (
    <MotionSection className="w-full py-0 sm:py-10">
      <div className="relative w-full overflow-hidden min-h-[400px] sm:min-h-0">
        <MotionImage className="w-full h-[400px] sm:h-auto">
          <img
            src="/images/sectionimages/cta.png"
            alt="Call to action"
            className="w-full h-full object-cover sm:h-auto sm:object-contain"
          />
        </MotionImage>

        <div className="absolute inset-0 flex items-center justify-center sm:justify-end">
          <MotionDiv className="px-4 sm:px-6 md:px-8 lg:px-10 max-w-md sm:max-w-2xl text-center sm:text-left text-white space-y-3" delay={0.06}>
            <h2 className="text-lg sm:text-xl md:text-2xl font-bold leading-tight">
              THESE ARE NOT YOUR AVERAGE
              <br />
              DOORMATS
            </h2>
            <p className="text-[11px] sm:text-xs md:text-sm leading-relaxed max-w-2xl">
              Ethically sourced and made from sustainable materials, our signature embossed range offer a richly
              textured, durable, and fade-resistant finish. Our doormats are outstanding quality and beautifully
              delivered to your front door.
            </p>
            <button className="mt-2 inline-flex items-center justify-center rounded-full bg-black px-6 py-2 text-xs font-semibold text-white shadow hover:bg-gray-900 transition-colors">
              <MotionButton>See Collection</MotionButton>
            </button>
          </MotionDiv>
        </div>
      </div>
    </MotionSection>
  )
}
